<template>
	<div class="flex flex-col gap-1" :class="{'text-center': centerContent}">
		<n-card
			size="small"
			:class="{'bg-transparent': variant === 'ultra-compact'}"
			:theme-overrides="{
				paddingSmall:
					variant === 'compact'
						? '8px'
						: ['ultra-compact', 'article-box'].includes(variant)
						? '0'
						: undefined,
			}"
			:bordered="!['ultra-compact', 'article-box'].includes(variant)"
			:id="variant === 'full' ? 'asitmifo-box' : undefined"
		>
			<div
				class="flex flex-col"
				:class="{'gap-3': variant !== 'article-box', 'gap-1': variant === 'article-box'}"
			>
				<div
					v-if="variant === 'full'"
					class="asitmifo__title text-center uppercase font-bold leading-none"
				>
					{{
						stringaMultilingua(
							"Informazioni sull'apertura",
							'Opening information',
							'Eröffnungsinformationen'
						)
					}}
				</div>
				<div
					class="flex flex-col"
					:class="{
						'gap-3': ['full'].includes(variant),
						'gap-2': ['article-box'].includes(variant),
						[`md:flex-row ${
							businessHoursData?.services?.length === 1 ? 'md:items-center' : 'md:items-start'
						} gap-2`]: variant === 'compact',
						'flex-col-reverse gap-1 items-start': variant === 'ultra-compact',
					}"
				>
					<business-hours
						v-if="businessHoursData"
						:data="businessHoursData"
						:locale="locale"
						:minisite="minisite"
						:variant="variant"
						:otherHoursAsAnchor="otherHoursAsAnchor"
						:centerContent="centerContent"
						:class="{'md:w-6/12': variant === 'compact'}"
					/>
					<minisites-updates
						v-if="minisitesUpdatesData"
						:data="minisitesUpdatesData"
						:locale="locale"
						:variant="variant"
						:business-hours-services-count="businessHoursData?.services?.length"
						:class="{'md:flex-1': variant === 'compact'}"
					/>
				</div>
				<last-updated-text
					v-if="['full', 'article-box'].includes(variant) && lastUpdated"
					:updated-on="lastUpdated"
					:locale="locale"
				/>
			</div>
		</n-card>
	</div>
</template>

<script setup>
	import BusinessHours from './BusinessHours.vue'
	import MinisitesUpdates from './MinisitesUpdates.vue'
	import {NCard} from 'naive-ui'
	import {toRefs, computed} from 'vue'
	import LastUpdatedText from '../global/LastUpdatedText.vue'

	const props = defineProps({
		businessHoursData: {
			type: Object,
		},
		minisitesUpdatesData: {
			type: Object,
		},
		variant: {
			type: String,
			default: 'full',
		},
		locale: {
			type: String,
			default: 'it',
		},
		minisite: Object,
		otherHoursAsAnchor: {
			type: Boolean,
			default: false,
		},
	})
	const centerContent = computed(() => ['article-box'].includes(props.variant))
	const {businessHoursData, minisitesUpdatesData, variant, locale, minisite} = toRefs(props)
	const lastUpdated = computed(() => {
		// Find the max updated_at date in the minisitesUpdatesData array
		const maxMinisitesDate = minisitesUpdatesData.value
			? minisitesUpdatesData.value.reduce((latestDate, current) => {
					return current.updated_at > latestDate ? current.updated_at : latestDate
			  }, '0000-00-00')
			: '0000-00-00'

		// Compare with businessHoursData updatedOn date
		return (businessHoursData.value?.updatedOn || '0000-00-00') > maxMinisitesDate
			? businessHoursData.value?.updatedOn
			: maxMinisitesDate
	})
	const language = computed(() => locale.value.split('-')[0])

	function stringaMultilingua(...params) {
		switch (language.value) {
			case 'it':
				return params[0]
			case 'de':
				return params[2]
			default:
				// 2
				return params[1]
		}
	}
</script>
